import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

export abstract class SecurityZonesModelBase extends BaseModel
{
    abstract getSecurityZones(): Promise<ZoneFeature[] | null>;
}

let SecurityZonesModel: SecurityZonesModelBase|null = null;

function setSecurityZonesModel(model: SecurityZonesModelBase)
{
    SecurityZonesModel = model;
}

export { SecurityZonesModel, setSecurityZonesModel };
